<template>
	<a href="#" title="Actualizar" v-on:click.prevent="update">
    	<i class="material-icons">refresh</i> <span class="d-xl-none d-lg-none">Actualizar</span>
  	</a>
</template>
<script>
	export default {
		methods: {
			update: function(){
				window.location = window.location.href.split("?")[0];
			}
		}
	}
</script>